import ApiProxy from "@ts/ApiProxy"
import { Emitter } from "strict-event-emitter"
import { ComponentElem } from "../interfaces";

let _sortDic: {[key:string]: string},
  _sortList: { text: string, value: any }[];

export namespace Common
{
  export type ActivityPromoteData = {    
    "text": string
    "button_text": string
    "url": string
    "target"?: string
    "id": string
  }

  export type SendFormError = {
    message?: string | ResponseMessage;
    scroll_to_id?: string;
    field_errors: FieldError[];
  }

  export type ResponseMessage = {
    title?: string;
    text?: string;
  }

  export type FieldError = {
    data_field: string;
    data_group: string;
    error_text: string;
  }

  export type ImageWithThumb = {
    id: string,
    image_src: string,
    thumb_src: string
  }

  export enum Align
  {
    "left-top" = 1,
    "center-top" = 2,
    "right-top" = 3,
    "left-center" = 4,
    "center-center" = 5,
    "right-center" = 6,
    "left-bottom" = 7,
    "center-bottom" = 8,
    "right-bottom" = 9
  }

  export type CommonPageData = {
    ez_point_ratio: EZPointRatio;
    activity?: ActivityPromoteData;
    login_urls: LoginUrls;
    login_state: LoginState;
    search_page_path: String;
    sort_data: SortData[];
  }

  export type EZPointRatio = {
    point_to_cash: number,
    price_to_point: number
  }

  export type LoginUrls = {
    line: string,
    facebook: string,
    google: string
  }

  export type LoginState = {
    is_login: boolean;
    info?: MemberInfo;
  }

  export type MemberInfo = {
    id: string;
    rank: string;
    ezpoint: number;
    basic: BasicInfo;
  }

  export type BasicInfo = {
    first_name?: string;
    surname?: string;
    picture?: string;
    email: string;
    phone?: Phone;
    country?: Country;
  }

  export type Country = {
    "name": string,
    "iso2": string
  }

  export type Phone = {
    "name": string,
    "iso2": string,
    "full": string,
    "dial_code": string,
    "area_code": string
  }
  
  export type Address = {
    county:   string;
    district: string;
    detail:   string;
  }
  

  export type PassengerData = {
    id?: string;
    first_name: string;
    surname: string;
    country: Common.Phone;
    birth_date: Date;
    address?: Common.Address;
    emergency_contact: EmergencyContact;
    id_number: string;
    remark: string;
    id_number_is_passport: boolean;
    save_as_common_passenger?: boolean;
    gender: "female" | "male";
    height?: number;
    weight?: boolean;
  }

  export type EmergencyContact = {
    name: string;
    phone: Common.Phone;
  }

  export type SortData = {
    name: string;
    icon: string;
  }

  export function getSortValueList(): { text: string, value: any }[]
  {
    if(_sortList) return _sortList;

    let list: SortData[] = ApiProxy.getCommonPageData().sort_data,
      result: { text: string, value: any }[] = [];

    result.push({text: "不限制", value: {id:"", name: ""}});

    list.forEach((data) =>
    {
      result.push({
        text: data.name,
        value: data
      })
    });

    _sortList = result;

    return _sortList;
  }

  export function getSortDic()
  {    
    if(_sortDic) return _sortDic;

    let list: SortData[] = ApiProxy.getCommonPageData().sort_data,
      dic: {[key: string]: string} = {};

    list.forEach((data)=>
    {
      dic[data.name] = data.name;
    });

    _sortDic = dic;

    return _sortDic;
  }

  export type PagingInfo = {
    total_count: number,
    start_index: number,
    page_size: number
  }

  export interface CollapseRelational
  {
    emitter: Emitter<{ change: [value: string] }>
  }

  export interface InputComponent
  {
    update(): void;
    getValue(): any;
    isOk(): boolean;
    changePattern?(patternName: string): void;
    emitter: Emitter<{ change: [value: string, isOk: boolean] }>
    reset(): void;
  }

  export interface FormField
  {
    getValue(): string | boolean | string[];
    getDataField(): string;
    getDataGroup(): string;
    isOptional(): boolean;
    toggleError?(errorOn: boolean, message?: string): void;
  }

  export type CouponData = {
    id: string;
    name: string;
    value: number;
    is_percentage: boolean;
    rule: string;
    active_date: string;
    due_date: string;
    useable: boolean;
  }

  export type FormDataResult = {
    formData: any
    isReady: boolean
    firstErrorElem?: ComponentElem
    errorFeedback?: {title?:string, text?: string}
  }
}